import { Footer } from "../../layouts/footer";
import { useState } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import config from '../../../config'

const AddCategory = () => {
  const [formData, setFormData] = useState({
    catname: "",
    details: "",
    image: null,
  });

  const navigate = useNavigate(); // Initialize useNavigate

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("catname", formData.catname);
    data.append("details", formData.details);
    data.append("image", formData.image);

    try {
      const response = await fetch(`${config.baseURL}/categories`, {
        method: "POST",
        body: data,
      });

      const result = await response.json();
      if (result.status) {
        alert("Category added successfully!");
        setFormData({ catname: "", details: "", image: null });

        // Redirect to the desired page
        navigate("/admin/categories");
      } else {
        alert(result.message || "Failed to add category");
      }
    } catch (error) {
      console.error("Error adding category:", error);
      alert("An error occurred while adding the category");
    }
  };

  return (
    <div className="flex flex-col gap-y-4">
      <h1 className="title">Add Category</h1>
      <div className="card">
        <div className="card-header">
          <p className="card-title">Add Category</p>
        </div>
        <div className="card-body p-0">
          <div className="relative h-[500px] w-full flex-shrink-0 overflow-auto rounded-none [scrollbar-width:_thin]">
            <form onSubmit={handleSubmit}>
              <div className="space-y-12">
                <div className="border-b border-gray-900/10 pb-12">
                  <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div className="sm:col-span-3">
                      <label
                        htmlFor="category_name"
                        className="block text-sm/6 font-medium text-white"
                      >
                        Category Name
                      </label>
                      <div className="mt-2">
                        <input
                          id="category_name"
                          name="catname"
                          type="text"
                          placeholder="Enter Category Name..."
                          value={formData.catname}
                          onChange={handleInputChange}
                          autoComplete="given-name"
                          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                      </div>
                    </div>
                    <div className="sm:col-span-3">
                      <label
                        htmlFor="image"
                        className="block text-sm/6 font-medium text-white"
                      >
                        Category Image
                      </label>
                      <div className="mt-2">
                        <input
                          id="image"
                          name="image"
                          type="file"
                          onChange={handleFileChange}
                          autoComplete="family-name"
                          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                      </div>
                    </div>

                    <div className="col-span-full">
                      <label
                        htmlFor="details"
                        className="block text-sm/6 font-medium text-white"
                      >
                        Category details
                      </label>
                      <div className="mt-2">
                        <textarea
                          id="details"
                          name="details"
                          rows="4"
                          value={formData.details}
                          onChange={handleInputChange}
                          className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                          placeholder="Enter additional details here..."
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-full">
                <button
                  type="submit"
                  className="w-full rounded-md bg-[#2563EB] px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCategory;